import './App.css';
import React, {useState} from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

//Components
import Navbar from './components/navbar/Navbar';
import Forum from "./components/forum/Forum";
import Footer from './components/Footer';
import NewUser from "./components/NewUser";
import User from "./components/user/User";

function App() {
  const [newUser, setNewUser] = useState(false);

  return (
    <div className="App">
      {newUser && <NewUser setNewUser={setNewUser}/>}
      <Router>
        <Navbar setNewUser={setNewUser}/>
        <Route exact path="/"><Redirect to="/forum"/></Route>
        <Route path="/forum" component={Forum} />
        <Route path="/users/:authorID" component={User} />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
